import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import EFPic from '@/components/UI/EFPic';
import { useGlobal } from '@/utils/useGlobal';
import EFArrowRight from '@/components/UI/svg/CSR/Icons/EFArrowRight';
import EFVideo from '@/components/UI/EFVideo';
// import { TweenMax } from 'gsap';

export default function H() {
    const { useLang, useEffect, useState, Link } = useGlobal();
    const { t } = useLang('csr');
    const donateData = [
        {
            dTitle: t('secH_dItem3_title'),
            dText: [t('secH_list3_desc1')],
            dImg: ['/img/csr/h5/8_3.jpg', '/img/csr/h5/8_3.jpg'],
            imgLink: 'https://youtu.be/sGzDEKQEqag',
            // video: ['/video/csr/2.mp4', '/video/csr/2.mp4'],
            // link: {
            //     text: t('secH_interview'),
            //     href: 'https://prtimes.jp/main/html/rd/p/000000071.000050601.html',
            // },
        },
        {
            dTitle: t('secH_dItem1_title'),
            dAddress: t('secH_dItem1_address'),
            dImg: ['/img/csr/h5/8_1.webp', '/img/csr/h5/8_1.jpg'],
            dProfile: t('secH_dItem1_profile'),
            dText: t('secH_dItem1_text'),
            link: 'https://blog.ecoflow.com/jp/experiencing-power-outage/',
        },
        {
            dTitle: t('secH_dItem2_title'),
            dImg: ['/img/csr/h5/8_2.webp', '/img/csr/h5/8_2.jpg'],
            dText: t('secH_dItem2_text'),
            link: 'https://prtimes.jp/main/html/rd/p/000000071.000050601.html',
        },
    ];
    const [winW, setWinW] = useState(375);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setWinW(window.innerWidth);
        }
    }, []);

    const [active, setActive] = useState(0);

    const letters: [string] = t('secH_title').split('');

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        // const layoutH = typeof window !== 'undefined' ? window.innerHeight : 750;
        // title文字动效： 与A中的staggerFromTo同效，但css性能更优
        //　CSS動画：性能がよりよい
        new ScrollMagic.Scene({
            triggerElement: '.csr_h5_H', // 触发元素
            triggerHook: 1, // 1: 进入 0: 离开 0.5 中间
            offset: 220, // 触发时机偏移量: 文字进入视窗1/4时
        })
            .setClassToggle('.csr_h5_H .innerBox', 'enter')
            .addTo(controller);
    }, []);

    return (
        <div className={`csr_h5_H ${css.csr_h5_H}`}>
            <div className="innerBox">
                <p className="title">
                    {letters?.map((letter: any, k: number) => (
                        <span className={`letter_b letter_${k}`} key={k}>
                            {letter}
                        </span>
                    ))}
                </p>
                <div className={`donate`}>
                    <div className="dBoxSwiper">
                        <Swiper
                            className="dSwiperLists"
                            loop
                            initialSlide={0}
                            preloadImages={false}
                            lazy={true}
                            centeredSlides={true}
                            spaceBetween={(winW / 375) * 30}
                            slidesPerView={'auto'}
                            grabCursor={true}
                            navigation={true}
                            // onSwiper={(swiper: any) => setSwiper(swiper)}
                            onSlideChange={(swiper: any) => setActive(swiper?.activeIndex % donateData.length)}
                        >
                            {donateData?.map((list: any, k: number) => (
                                <SwiperSlide key={k} className="dSwiperList">
                                    <p className="dItemTitle">{list?.dTitle}</p>
                                    {list?.dAddress && <p className="dItemAddress">{list?.dAddress}</p>}
                                    {list?.dImg && !list?.imgLink && (
                                        <div className="dPic">
                                            <EFPic src={list?.dImg} alt={list?.dTitle} aria-label={list?.dTitle} />
                                        </div>
                                    )}
                                    {list?.dImg && list?.imgLink && (
                                        <Link href={list?.imgLink} className="dPic">
                                            <EFPic src={list?.dImg} alt={list?.dTitle} aria-label={list?.dTitle} />
                                        </Link>
                                    )}
                                    {list?.video && <EFVideo className="dPic" sources={list?.video} aria-label={list?.dTitle} />}
                                    {list?.dProfile && <p className="dItemProfile">{list?.dProfile}</p>}
                                    <p className="dItemText">{list?.dText}</p>
                                    {list?.link && (
                                        <div className="dItemInterviewContentBox" onClick={() => window.open(list?.link, '_blank')}>
                                            <span className="moreText">{t('secH_interview')}</span>
                                            <span className="arrow">
                                                <EFArrowRight width="0.22rem" height="0.13rem" />
                                            </span>
                                        </div>
                                    )}
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <div className="pagination">
                            {donateData?.map((_item: any, k: number) => (
                                <li className={`pageItem ${active == k ? 'active' : ''}`} key={k}></li>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
